'use client';

import { useTheme } from 'next-themes';
import { useEffect } from 'react';

const COOKIE_NAME = 'cm_theme';
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export function ThemeCookieSync(): null {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    if (!resolvedTheme) {
      return;
    }
    // biome-ignore lint/suspicious/noDocumentCookie: simple theme cookie, Cookie Store API not universally supported
    document.cookie = `${COOKIE_NAME}=${resolvedTheme};path=/;max-age=${ONE_YEAR_SECONDS};SameSite=Lax`;
  }, [resolvedTheme]);

  return null;
}
